// extracted by css-extract-rspack-plugin
export default {"textInputWrapper":"_c2a8dd3a","isHighlighted":"_e0281ba9","headerInput":"_b40846b","animatedPlaceholderPadding":"_5138e60f","usePaddingLeft":"_b952cceb"};